<template>
  <div class="question-answer-card">
    <!-- Header -->
    <div class="question-header">
      <div class="header-title">{{ questions.title }}</div>
      <div v-html="questions && questions.description"></div>
    </div>

    <!-- Danh sách câu hỏi -->
    <div v-for="question in questions && questions.questions" :key="question.id" class="question-block">
      <QuestionItem :question="question" :type-question="questions && questions.type" />

      <!-- Câu trả lời học viên -->
      <span
          v-if="studentAnswer(question)"
          class="student-answer"
          :class="handleAnswer(question) ? 'answer-correct' : 'answer-wrong'"
      >
        {{ studentAnswer(question) }}
      </span>
      <span v-else class="student-answer answer-empty">
        Học viên không có câu trả lời
      </span>

      <!-- Đáp án đúng -->
      <div class="correct-answer">
        Correct answer:
        <span class="answer-correct">{{ question && question.correctAnswers && question.correctAnswers.join(', ') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import QuestionItem from "@/view/pages/classes/components/QuestionItem.vue";

export default {
  name: 'QuestionAndAnswer',
  components: {
    QuestionItem
  },
  props: {
    questions: {
      type: Object,
      required: true
    },
    answers: {
      type: Array,
      required: true
    }
  },
  methods: {
    handleAnswer(question) {
      return this.studentAnswer(question).toLowerCase() === (question && question.correctAnswers && question.correctAnswers.join(', ').toLowerCase())
    },
    studentAnswer(question) {
      if (this.answers && this.answers.length > 0 && question) {
        const found = this.answers.find(answer => answer.id === question.id)
        return found && found.userAnswer ? found.userAnswer.join(', ') : null
      }
      return null
    }
  }
}
</script>

<style scoped>
.question-answer-card {
  display: flex;
  flex-direction: column;
  border: 1px solid #ddd;
  gap: 6px;
  border-radius: 6px;
  padding: 16px 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

.question-header {
  background-color: #1e40af; /* bg-header-color */
  color: white;
  padding: 16px 24px;
  border-radius: 8px;
  margin-bottom: 12px;
}

.header-title {
  font-weight: bold;
  margin-bottom: 4px;
}

.question-block {
  margin-bottom: 12px;
}

.student-answer {
  display: flex;
  padding: 8px 6px;
  border: 1px solid #ddd;
  border-radius: 4px;
  margin: 6px 0;
}

.answer-correct {
  color: #22c55e; /* xanh lá */
}

.answer-wrong {
  color: #ef4444; /* đỏ */
}

.answer-empty {
  color: #eab308; /* vàng */
}

.correct-answer {
  padding: 4px 8px;
  font-weight: bold;
  color: #000;
}
</style>
